export default {
  plate: null,
  sinisterVersion: null,
  mechanicalWorkshop: null
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/carinspectionheader/model/carinspectionheadermodel.js